<template>
  <div id="application_pay_outer">
    <div>
      <div class="pay-title">
        <el-radio v-model="payType" :label="1" :disabled="!isMenuCanClicked"><span class="iconfont" style="margin-right: 10px;">&#xe609;</span>微信支付</el-radio>
        <el-radio v-model="payType" :label="2" :disabled="!isMenuCanClicked"><span class="iconfont" style="margin-right: 10px;">&#xe6c9;</span>对公转账</el-radio>
      </div>
      <div v-if="payType == 1" id="wechat_pay_outer" style="margin-top: 30px;text-align: center;">

        <wechat-pay-card v-bind:pay-model="payInforData"
                         v-on:pay-clicked="payButtonClicked" ></wechat-pay-card>

        <div style="margin-top: 15px;color: #fc1a34;font-weight: bold;">{{wechatPayDesc}}</div>
        <div v-if="showQrCode" style="margin-top: 10px;color: #666;">扫码付款</div>
      </div>

      <div v-else style="margin-top: 30px;text-align: left;">
        <div class="bank-recipient">
          <div>{{bankPayDesc}}</div>
          <div>收款账号</div>
          <div>户名：上海市篮球协会</div>
          <div>开户行：建设银行上海威海路支行</div>
          <div>账号：31001537100056000566</div>
        </div>
        <div class="pay-voucher">
          <div>上传转账凭证：</div>
         <div v-if="user.status == 10" >
           <!-- <img :src="voucherUrl" style="width: 100%;max-width: 300px;height: auto;"/> -->
          <el-image fit="cover" style="width: 100%;max-width: 300px;height: auto;" :src="voucherUrl" :preview-src-list="[voucherUrl]" />

         </div>
          <el-upload v-else
            class="voucher-upload"
            action="https://api.shslqxh.com/upload/files"
            :headers="headers"
            name="files"
            :show-file-list="false"
            :on-success="handleVoucherUploadSuccess"
            >
            <img v-if="voucherUrl" :src="voucherUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
    </div>
    <template v-if="payType == 2">

      <el-button v-if="user.status == 10" class="btn-gray" :disabled="true" round>确认中，请耐心等待</el-button>
      <el-button v-else-if="user.status == 11" class="btn-gray" @click="nextButtonClicked" round>转账凭证验证失败，请重新上传</el-button>
      <el-button v-else class="btn-next" @click="nextButtonClicked" round>提交</el-button>

    </template>

  </div>
</template>

<script>
  import '../../../js/jquery.qrcode.min';
  import WechatPayCard from "../../common/WechatPayCard";
  import WeixinManager from "../../../js/weixin.config";
export default {
  name: "GroupApplicationPaying",
  components: {
    WechatPayCard
  },
  props: [
    'status'
  ],
  data() {
    return {
      payType: 1,
      headers: {},
      voucherUrl: null,
      checkInterval: null,
      payInforData: null,
      tradeType: null,
      showQrCode: true,
      neededAutoCheckPayStatus: false,
      isMenuCanClicked: true,
      code: null,
    }
  },
  watch: {
    // payType(newVal, oldValue) {
      // if (newVal == 1) {
        // this.dealWithPayCodeImg();
      // }
    // }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    httpManager() {
      return this.$store.state.http;
    },
    dataManager() {
      return this.$store.state.dataStore;
    },

    wechatPayDesc() {
      let user = this.user;
      if (user == null) {
        return null;
      }
      let medal = user.medal;
      if (medal == 1) { // 需要实体铜牌
        return '支付金额：2500元（含铜牌制作费500元）';
      } else { // 不需要实体铜牌
        return '支付金额：2000元';
      }
    },
    bankPayDesc() {
      let user = this.user;
      if (user == null) {
        return null;
      }
      let medal = user.medal;
      if (medal == 1) { // 需要实体铜牌
        return '转账金额：2500元（含铜牌制作费500元）';
      } else { // 不需要实体铜牌
        return '转账金额：2000元';
      }
    }
  },
  destroyed() {
    this.closeInterval();
  },

  mounted() {
    // status: 2 待支付； 10 银行转账确认中; 11 银行转账确认失败
    let token = this.$store.state.dataStore.getToken();
    this.headers.token = token;
    this.initConfig();

  },

  methods: {
    initConfig() {
      let user = this.user;
      if (user == null) {
        let _this = this;
        setTimeout(function function_name(argument) {
          _this.initConfig();
        }, 50);
        return;
      }
      let status = user.status;

      if (status == 10) { // 银行卡转账确认中。。。
        this.payType = 2;
        this.isMenuCanClicked = false;
        this.voucherUrl = this.user.voucher != undefined ? this.user.voucher : null;
      } else {
        if (status == 11) {
          this.payType = 2;
        }
        this.isMenuCanClicked = true;
        this.initPayParams();
        this.initAutoCode();
        this.loadQrCodeData();
      }
    },

    initPayParams() {
      if (this.isPc()) { // pc端
        this.tradeType = 'NATIVE';
        this.showQrCode = true;
        this.neededAutoCheckPayStatus = true;
      } else { // 移动端
        this.showQrCode = false;
        if (this.isWeixin()) {
          this.tradeType = 'JSAPI';
          this.neededAutoCheckPayStatus = false;
        } else {
          this.tradeType = 'MWEB';
          this.neededAutoCheckPayStatus = true;
        }
      }
    },

    initAutoCode() {
      if (this.tradeType == 'JSAPI') {
        let query = this.$route.query;
        let state = query.state;
        if (state == this.weichatAutoState.pay) {
          let code = query.code;
          if (code != undefined) {
            this.code = code;
            this.$router.push({
              name: this.$route.name,
              params: this.$route.params,
              query: {}
            });
          }
        } else {
          let redirect_url = window.location.href;
          WeixinManager.jsapi_payAutorize(redirect_url);
        }
      } else if (this.tradeType == 'MWEB') {
        //outTradeNo
        let query = this.$route.query;
        let outTradeNo = query.outTradeNo;
        if (outTradeNo != undefined && outTradeNo != null && outTradeNo.length > 0) {
          //...更新状态
          this.checkPayStatusAtBegin(outTradeNo);
        }
      }
    },

    payButtonClicked() {
      let params = this.payInforData;
      if (params == null) {
        return;
      }
      let _this = this;
      if (this.tradeType == 'JSAPI') {
        WeixinManager.jsapi_sendPayRequest(params, function (data) {
          _this.$toast('支付成功！');
          _this.checkPayStatus();
        }, function (data) {
          // _this.$toast(data.err_msg);
        });
      } else {
        let mwebUrl = params.mwebUrl;
        if (mwebUrl != null && mwebUrl.length > 0) {
          let url =  window.location.href;
          if (this.isSafari()) {
            url += "?outTradeNo=" + params.outTradeNo;
            url = encodeURI(url);
          }
          mwebUrl += '&redirect_url=';
          mwebUrl += url;
          window.open(mwebUrl, '_self');
        }
      }
    },

    loadQrCodeData() {
      let params = {
        productId: -1,
        tradeType: this.tradeType
      };
      if (this.code != null) {
        params.code = this.code;
      }

      let _this = this;
      this.httpManager.ajax.getPayUnifiedorderData(params, function (data) {
        let code = data.code;
        if (code == 0) {
          _this.payInforData = data.data;
          _this.code = null;
          if (_this.neededAutoCheckPayStatus) {
            _this.startInterval();
          }
        }
      }, function (data) {
        _this.$toast('请求失败，请刷新！');
      });
    },

    weichatPaySuccess() {
      this.$toast('支付成功！');
      this.$emit('paySuccess');
    },

    checkPayStatusAtBegin(outTradeNo) {
      let params = {
        outTradeNo
      };
      let _this = this;
      this.httpManager.ajax.getPayWxPayCheckData(params, function (data) {
        let code = data.data;
        if (code == 1) {
          _this.checkInterval = null;
          _this.$router.push({
            name: _this.$route.name,
            params: _this.$route.params,
            query: {}
          });
          _this.weichatPaySuccess();
          //...
        } else {
          _this.startInterval();
        }

      }, function (data) {
        _this.startInterval();
      });
    },


    checkPayStatus() {
      let outTradeNo = this.payInforData.outTradeNo;
      let params = {
        outTradeNo
      };
      let _this = this;
      this.httpManager.ajax.getPayWxPayCheckData(params, function (data) {
        let code = data.data;
        if (code == 1) {
          _this.checkInterval = null;
          _this.weichatPaySuccess();
          //...
        } else {
          _this.startInterval();
        }

      }, function (data) {
        _this.startInterval();
      });
    },

    startInterval() {
      if (!this.neededAutoCheckPayStatus || this.payInforData == null) {
        return;
      }
      this.checkInterval = setTimeout(this.checkPayStatus, 3 * 1000);
    },
    closeInterval() {
      if (this.checkInterval != null) {
        clearTimeout(this.checkInterval);
        this.checkInterval = null;
      }
    },

    nextButtonClicked() {
      let voucher = this.voucherUrl;
      if (voucher == null) {
        this.$toast('请上传转账凭证！');
        return;
      }
      let params = {
        productId: -1,
        tradeType: 'REMIT',
        voucher,
      };

      let _this = this;
      this.httpManager.ajax.getPayUnifiedorderData(params, function (data) {
        let code = data.code;
        if (code == 0) {
          _this.$toast('提交成功！');
          _this.$emit('bankSubmitSuccess');
          return;
        }
      }, function (data) {
        _this.$toast('提交失败，请重试！');
      });
    },

    handleVoucherUploadSuccess(res, file) {
      if (typeof  res == 'string') {
        this.voucherUrl = res;

      }
    },
  }
}
</script>

<style scoped>
  #application_pay_outer {
    padding: 15px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }

  #application_pay_outer .pay-title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
    margin-top: 30px;
  }

  #appli_pay_card {
    width: 200px;
    height: 200px;
    margin: auto;
  }

  #application_pay_outer /deep/ .is-checked .el-radio__inner {
    background-color: #fc1a34;
    border: solid 1px #fc1a34;
  }

  #application_pay_outer /deep/ .is-checked .el-radio__label {
    color: #fc1a34;
  }

  #application_pay_outer /deep/ .el-radio__inner:hover {
    border: solid 1px #fc1a34;
  }

  .bank-recipient {
    font-size: 1rem;
    font-weight: bold;
  }

  .bank-recipient > div:not(:first-child) {
    margin-top: 5px;
  }

  .pay-voucher {
    margin-top: 20px;
  }


  #group_application_outer .voucher-upload /deep/ .el-upload input {
    display: none;
  }

  #group_application_outer .voucher-upload {
    margin-top: 20px;
  }

  #group_application_outer .voucher-upload /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  #group_application_outer .voucher-upload /deep/ .el-upload:hover {
    border-color: #fc1a34;
  }
  #group_application_outer .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  #group_application_outer .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }

  #group_application_outer .btn-next {
    background-color: #fc1a34;
    border-color: #fc1a34;
    width: 200px;
    padding-left: 0;
    padding-right: 0;
    color: white;
    margin-top: 50px;
  }

  #group_application_outer .btn-gray {
    background-color: gray;
    border-color: gray;
    /* width: 200px; */
    min-width: 200px;
    padding-left: 15px;
    padding-right: 15px;
    color: white;
    margin-top: 50px;
  }

  #wechat_pay_outer {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex-wrap: nowrap;
    align-items: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/group/groupApplicationVues/GroupApplicationPaying.vue